import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑" className="flex items-center flex-wrap gap-1.5 text-xs text-foreground-500">
      <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-1">
        <i className="ri-home-4-line"></i>
        首页
      </Link>
      {items.map((c) => (
        <span key={c.label} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-foreground-300"></i>
          {c.to ? (
            <Link to={c.to} className="hover:text-primary-600 transition-colors cursor-pointer">
              {c.label}
            </Link>
          ) : (
            <span className="text-foreground-800 font-medium">{c.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}